// مكوّن موحَّد لرأس إيصالات الطباعة. يعرض الشعار والاسم بشكل متّسق عبر
// كل المعاينات (استقبال، نقاط بيع، خروج، اشتراكات، شفتات) ليبقى الـrebranding
// في مكان واحد.
//
// الشعار: شعار المركز المرفوع من «الإعدادات ← إعدادات الطباعة» إن وُجد، وإلا
// علامة النظام كما كانت. وخيار «إظهار الشعار في الطباعة» إذا أُطفئ فلا يُرسَم
// شعار إطلاقاً (ولا مساحة فارغة) ويبقى الاسم وحده.
//
// ⚠️ ملاحظة الطباعة: الشعار هنا يُطبع على طابعة حرارية 80mm أحادية اللون،
// لذلك لا نستخدم CSS mask أو filter ملوّن — فقط <img> مباشر بالـ fill الأصلي.
// الأبعاد تُضبط بـ max-width/max-height مع width/height تلقائيين، فتبقى نسبة
// أبعاد الصورة الأصلية بلا تمديد ولا تشويه.
import { useAuth } from './useAuth.js';
import { usePrintLogo, useBusinessName } from './useSettings.js';

export function ReceiptBrand({ subtitle, size = 120 }) {
  // اسم الصالة = «اسم الصالة على الإيصالات» من الإعدادات إن حُدِّد، وإلا اسم
  // الشركة صاحبة الحساب، وإلا اسم النظام.
  const company = useAuth((s) => s.company);
  const brand = useBusinessName(company && company.name);
  const { url, enabled, visible } = usePrintLogo();

  // لا شعار مخصّص → علامة النظام (السلوك السابق). الخيار مُطفأ → بلا شعار.
  const src = visible ? url : (!url && enabled ? '/kidzo-mark.png' : null);

  return (
    <div className="flex flex-col items-center mb-1">
      {src ? (
        <img
          className="receipt-logo"
          src={src}
          alt={brand}
          style={{
            display: 'block',
            maxWidth: size * 1.6,
            maxHeight: size,
            width: 'auto',
            height: 'auto',
            objectFit: 'contain',
            // لا drop-shadow ولا filter لضمان حواف نظيفة في الطباعة الحرارية
            imageRendering: 'crisp-edges'
          }}
        />
      ) : null}
      <div className="text-[15px] font-extrabold mt-1.5">{brand}</div>
      {subtitle ? <div className="text-[10px] text-ink-3">{subtitle}</div> : null}
    </div>
  );
}
